'use strict';

/* eslint global-require: 0 */

require('airbnb-js-shims');

require('./browser-only');
